<template>
  <div class="index-main-box">
    <div class="index-title">助力贷申请</div>
    <div class="form-box">
      <van-form @submit="onSubmit">
        <van-field
          class="full-width-input"
          v-model="form.limit"
          name="limit"
          label="需要多少"
          placeholder="请填写需要的额度"
          :rules="[{ required: true, message: '' }]"
        />
        <van-field
          class="full-width-input"
          v-model="form.username"
          type="text"
          name="username"
          label="姓名"
          placeholder="请填写姓名"
          :rules="[{ required: true, message: '' }]"
        />
        <van-field
          class="full-width-input"
          v-model="form.phone"
          type="text"
          name="phone"
          label="手机号"
          placeholder="请填写手机号"
          :rules="[{ required: true, message: '' }]"
        />
        <van-field
          class="full-width-input"
          v-model="form.work"
          type="text"
          name="work"
          label="工作"
          placeholder="请填写工作"
          :rules="[{ required: true, message: '' }]"
        />
        <van-field
          class="full-width-input"
          :value="form.repayment"
          type="text"
          name="repayment"
          label="还款方式"
          placeholder="请填写还款方式"
          :rules="[{ required: true, message: '' }]"
          readonly
          clickable
          @click="showRepayment = true"
        />
        <van-field
          class="full-width-input"
          v-model="form.bankNumber"
          type="text"
          name="bankNumber"
          label="本人银行卡号"
          placeholder="请填写本人银行卡号"
          :rules="[{ required: true, message: '' }]"
        >
        </van-field>
        <div class="bank-list-box">
          <div class="bank-item" v-for="(item, index) in bankList" :key="index">{{ item }}</div>
        </div>
        <van-field
          name="idCardFrontA"
          label="身份证人像面照片"
          class="full-width-input"
          :rules="[{ required: true, message: '请上传身份证人像面照片', validator: validateIdCardFrontA }]"
        >
          <template #input>
            <!-- <van-uploader v-model="form.uploader" multiple  /> -->
            <van-uploader
              v-model="form.idCardFrontA"
              :max-count="1"
              :after-read="handleIdCardFrontRead"
              upload-icon="photo"
            />
          </template>
        </van-field>
        <van-field name="idCardFrontB" label="身份证国徽面照片" class="full-width-input">
          <template #input>
            <!-- <van-uploader v-model="form.uploader" multiple  /> -->
            <van-uploader
              v-model="form.idCardFrontB"
              :max-count="1"
              :after-read="handleIdCardFrontRead2"
              upload-icon="photo"
            />
          </template>
        </van-field>
        <div style="margin: 16px">
          <van-button round block type="info" native-type="submit">提交</van-button>
        </div>
      </van-form>
      <van-popup v-model="showRepayment" position="bottom">
        <van-picker
          show-toolbar
          title="还款方式"
          :columns="repaymentColumns"
          @confirm="onConfirm"
          @cancel="showRepayment = false"
        />
      </van-popup>
    </div>
  </div>
</template>
<script>
import { Icon, Form, Button, Toast, Field, Popup, Picker, Uploader } from "vant";
import mixinViewModule from "@/mixins/view-module";

export default {
  name: "index",
  mixins: [mixinViewModule],
  data() {
    return {
      form: {
        limit: "",
        username: "",
        phone: "",
        work: "",
        repayment: "",
        bankNumber: "",
        idCardFrontA: [],
        idCardFrontB: [],
      },
      showRepayment: false,
      repaymentColumns: ["等额本息", "先息后本"],
      bankList: ["邮政", "中国银行", "招商银行", "兴业银行", "浦发银行"],
    };
  },
  components: {
    [Icon.name]: Icon,
    [Form.name]: Form,
    [Toast.name]: Toast,
    [Field.name]: Field,
    [Button.name]: Button,
    [Popup.name]: Popup,
    [Picker.name]: Picker,
    [Uploader.name]: Uploader,
  },
  created() {
    // 清除表单数据的缓存 如有需要可以使用
    // localStorage.removeItem("formData");
  },
  beforeDestroy() {},

  methods: {
    // 校验身份证人像面是否上传
    validateIdCardFrontA() {
      return this.form.idCardFrontA.length > 0;
    },
    onSubmit(values) {
      console.log("submit", values);
      this.form.printDate = this.formatTime(); // 获取当前时间
      // this.printDataForm = this.form;
      // 保存表单到 localStorage
      // localStorage.setItem("formData", JSON.stringify(this.form));
      try {
        localStorage.setItem("formData", JSON.stringify(this.form));
      } catch (e) {
        console.error("LocalStorage 存储失败：", e);
        Toast.fail("存储异常");
      }
      this.$router.push({
        path: "/wait",
        query: {},
      });
    },
    onConfirm(value) {
      this.form.repayment = value;
      this.showRepayment = false;
    },
    // 本地筛选文件格式，不上传
    handleIdCardFrontRead(file) {
      const validTypes = ["image/jpeg", "image/png", "image/jpg"];
      if (!validTypes.includes(file.file.type)) {
        Toast.fail("只能上传 JPG/PNG/JPEG 格式的图片");
        return false;
      }

      this.form.idCardFrontA = [
        {
          file: file.file,
          url: file.content,
          name: file.file.name,
        },
      ];

      return true;
    },
    // 本地筛选文件格式，不上传
    handleIdCardFrontRead2(file) {
      const validTypes = ["image/jpeg", "image/png", "image/jpg"];
      if (!validTypes.includes(file.file.type)) {
        Toast.fail("只能上传 JPG/PNG/JPEG 格式的图片");
        return false;
      }

      this.form.idCardFrontB = [
        {
          file: file.file,
          url: file.content,
          name: file.file.name,
        },
      ];

      return true;
    },
  },
};
</script>
<style lang="less" scoped>
.index-main-box {
  padding: 30px 0;
}
.index-title {
  text-align: center;
  font-size: 24px;
  font-weight: bold;
}
.form-box {
  padding-top: 50px;
}
.full-width-input {
  display: block;
  width: 100%;
}
::v-deep .van-field__label {
  padding-bottom: 10px !important;
  font-size: 16px;
  font-weight: bold;
  width: 200px;
}
::v-deep .van-picker__confirm {
  color: #1989fa;
}
.bank-list-box {
  display: flex;
  flex-wrap: wrap;
  padding: 5px 16px 20px;
}
.bank-item {
  font-size: 12px;
  padding: 4px 8px;
  color: #fff;
  background-color: rgba(25, 137, 250, 0.7);
  margin-right: 5px;
  border-radius: 5px;
}
::v-deep .van-uploader {
  .van-uploader__preview,
  .van-uploader__upload {
    width: calc(100vw - 32px);
    height: 200px;
    margin: 0;
    padding: 0;
  }

  .van-uploader__preview-image {
    width: 100%;
    height: 200px;
    img {
      width: 100%;
      height: 200px;
      object-fit: cover;
    }
  }
}

.custom-uploader-box {
  width: 100%;
  height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 40px;
  color: #1989fa;
  border: 2px dashed #1989fa;
  border-radius: 8px;
  box-sizing: border-box;
}
</style>
